import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class GenerateIRSFileService {
  private _generateIRSUrl = CONFIGURATION.basefile1094CURL;

  constructor(private http: Http) { }

  getTaxyears() {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
    headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
    return this.http.get(this._generateIRSUrl + 'irs-submit/tax-year', { headers: headers })
      .map((res: Response) => res.json());
  }

  getControlgroup(value: any) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json;charset=UTF-8');
    headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
    headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
    return this.http.get(this._generateIRSUrl + 'irs-submit/cg-ein-by-tax-year?taxYear=' + value, { headers: headers })
      .map((res: Response) => res.json());
  }

  getReportData(data: any) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.get(this._generateIRSUrl + `irs-submit/report-data?taxYear=${data.selectedYear}&ein=${data.selectedEIN}&controlGroup=${data.selectedControlGroup}`, { headers: headers })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/readytosubmitirs/readytosubmitirs.service.ts